<template>
  <div>
    <meeting-recording v-if="userIsRecordingBeam()"></meeting-recording>
    <meeting-participant v-else />
  </div>
</template>

<script>
  import MeetingParticipant from '../components/MeetingParticipant.vue'
  import MeetingRecording from '../components/MeetingRecording.vue'

  export default {
    name: 'Meeting',
    components: {
      MeetingParticipant,
      MeetingRecording
    },
    methods: {
      userIsRecordingBeam: function() {
        return ['record', 'record-guest'].includes(this.$route.params.role)
      },
    }
  }
</script>
